import { render, staticRenderFns } from "./LocalSwitcher.vue?vue&type=template&id=60959287&scoped=true"
import script from "./LocalSwitcher.vue?vue&type=script&lang=js"
export * from "./LocalSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LocalSwitcher.vue?vue&type=style&index=0&id=60959287&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60959287",
  null
  
)

export default component.exports